import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

type FlagState = {
  enabled: boolean;
  message: string | null;
  loading: boolean;
};

export function useFeatureFlag(feature: string): FlagState {
  const [state, setState] = useState<FlagState>({
    enabled: true,
    message: null,
    loading: true,
  });

  useEffect(() => {
    let active = true;
    supabase
      .from("system_health")
      .select("enabled, reason")
      .eq("feature", feature)
      .maybeSingle()
      .then(({ data }) => {
        if (!active) return;
        setState({
          enabled: data?.enabled ?? true,
          message: data?.reason ?? null,
          loading: false,
        });
      });

    const channel = supabase
      .channel(`system_health:${feature}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "system_health", filter: `feature=eq.${feature}` },
        (payload) => {
          const row = (payload.new ?? payload.old) as { enabled?: boolean; reason?: string | null } | null;
          if (!row) return;
          setState({
            enabled: row.enabled ?? true,
            message: row.reason ?? null,
            loading: false,
          });
        }
      )
      .subscribe();

    return () => {
      active = false;
      supabase.removeChannel(channel);
    };
  }, [feature]);

  return state;
}